import React from 'react';
import { browserHistory } from 'react-router';

/**
 * shared building blocks for the ?modal= popups, styled by modal.scss so every
 * modal and state uses the same header, status, alert and progress treatment
 */

// move to another ?modal= popup in place, e.g. from forgot password back to login
export const switchModal = (modal) => {
  browserHistory.replace(`${window.location.pathname}?modal=${modal}`);
};

// close the current popup; PopupDialog closes on clicks on [data-modal-dismiss]
export const DismissButton = ({ children, className = 'modal-btn modal-btn-primary' }) => (
  <button type="button" className={className} data-modal-dismiss>
    {children}
  </button>
);

export const ModalHeader = ({ title, sub, children }) => (
  <header className="modal-header">
    {children}
    <h2 className="modal-title">{title}</h2>
    {sub ? <p className="modal-sub">{sub}</p> : null}
  </header>
);

const ICONS = {
  success: (
    <polyline points="20 6 9 17 4 12" />
  ),
  error: (
    <React.Fragment>
      <line x1="12" y1="8" x2="12" y2="13" />
      <line x1="12" y1="16.5" x2="12" y2="16.5" />
    </React.Fragment>
  ),
  mail: (
    <React.Fragment>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <polyline points="3 7 12 13 21 7" />
    </React.Fragment>
  ),
};

// round icon above a title, for completed, failed and "check your inbox" states
export const ModalStatusIcon = ({ type }) => (
  <div className={`modal-status-icon modal-status-icon--${type}`} aria-hidden="true">
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
      {ICONS[type]}
    </svg>
  </div>
);

export const ModalAlert = ({ type = 'error', children }) => (
  <div className={`modal-alert modal-alert--${type}`} role={type === 'error' ? 'alert' : 'status'}>
    {children}
  </div>
);

// covers the card while something is in flight, leaving the content mounted
// underneath (the Braintree drop-in must not be unmounted mid-payment)
export const ModalProgress = ({ title, text }) => (
  <div className="modal-progress" role="status" aria-live="polite">
    <span className="modal-spinner" aria-hidden="true" />
    <p className="modal-progress-title">{title}</p>
    {text ? <p className="modal-progress-text">{text}</p> : null}
  </div>
);
